import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postScheduleMessageFailure,
  postScheduleMessageSuccess,
} from "../slices/features/postScheduleMessage";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postScheduleMessageSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);
    const response: AxiosResponse<any> = yield call(
      appservice.postScheduleMessage,
      baseUrl,
      id,
      data
    );
    yield put(postScheduleMessageSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postScheduleMessageFailure({ statusCode, statusText }));
  }
}

export function* watchPostScheduleMessage() {
  yield takeLatest(
    RequestTypes.POST_SCHEDULE_MSG_REQUEST,
    postScheduleMessageSaga
  );
}
